import type { ToastType } from './Toast'

const toaster = {
  current: (title?: string, content?: string, type?: ToastType) => true
}

export const getToaster = (): typeof toaster => toaster
